import React, { useEffect, useState } from "react"
import { ITestimonialsData } from "./interfaces";
import { isMobile } from "react-device-detect";
import Image from "next/image"
import PlaylistIcon from "@/components/SVG/PlaylistIcon";
import PlayIcon from "@/components/SVG/PlayIcon";
import Shimmer from "@/utils/shimmer";
import { STATIC_CDN } from "@/config/constants";

const ToppersTalk = ({items}: {items:ITestimonialsData[]}) => {
  const [maxCount, updateMaxCount] = useState(8);

  return (
    <>
      <div className='max-w-max flex'>
        <div className="flex flex-nowrap lg:flex-wrap overflow-x-auto gap-4 justify-start lg:justify-center p-2 snap-x snap-proximity">
          {items?.slice(0, maxCount)?.map((video:any,index) => (
            <a className="shrink-0 w-64 lg:w-72" key={index} href={`/question-answer/${video.questionId}`} rel="noindex nofollow">
              <div className="text-center shrink-0 h-full relative">
                <div className='absolute h-full w-full flex items-center justify-center'>
                  <PlayIcon className='h-8' />
                </div>
                <Image 
                  src={`${STATIC_CDN}/q-thumbnail/${video.questionId}.png`}
                  width={269}
                  height={80}
                  alt="fhgb" 
                  className='w-auto my-0'
                  placeholder="blur"
                  blurDataURL={Shimmer(600,400)}
                />
              </div></a>
          ))}
        </div>
      </div>
      { !isMobile &&
      <button className='underline text-accent mt-4' onClick={() => updateMaxCount(previousCount => isMobile ? previousCount + 3: previousCount + 5)}>View More</button>
      }
    </>
  )
}

export default ToppersTalk